import React, { useMemo, useState, createContext } from 'react';
import PropTypes from 'prop-types';
import createPersistedState from 'use-persisted-state';
import { ThemeProvider } from 'styled-components';
import { localStoragePrefix } from '../../lib/constants';

// Fix this in the future
const getStorage = () => {
	if (typeof window === 'undefined') {
		return null;
	}
	return window.sessionStorage;
};
const useSetTooltips = createPersistedState(`${localStoragePrefix} = toolTipsDisabled`, getStorage());

export const GameSettingsContext = createContext({});
export const GameSettingsManager = ({ children, numberOfColumns, tutorial }) => {
	const [toolTipsDisabled, setToolTipsDisabled] = useSetTooltips(true);
	const [hideFieldHighlighting, setHideFieldHighlighting] = useState(false);

	const memoizedValue = useMemo(() => ({
		toolTipsDisabled, setToolTipsDisabled, hideFieldHighlighting, setHideFieldHighlighting, numberOfColumns, tutorial,
	}), [hideFieldHighlighting, numberOfColumns, setToolTipsDisabled, toolTipsDisabled, tutorial]);

	return (
		<ThemeProvider theme={{ numberOfColumns }}>
			<GameSettingsContext.Provider value={memoizedValue}>
				{children}
			</GameSettingsContext.Provider>
		</ThemeProvider>

	);
};

GameSettingsManager.defaultProps = {
	tutorial: null,
	children: null,
};

GameSettingsManager.propTypes = {
	children: PropTypes.node,
	numberOfColumns: PropTypes.number.isRequired,
	tutorial: PropTypes.func,
};
